import { isCurrencyAvailable } from './currencyAvailability';

const CURRENCY_SIGNS = { USD: '$', EUR: '€', GBP: '£' };

export function currencyCode() {

    const currency = isCurrencyAvailable(window.currency) ? window.currency : 'USD';

    return currency.toUpperCase()
}

export function currencySign() {

    const key = currencyCode();

    return CURRENCY_SIGNS[key] ?? CURRENCY_SIGNS.USD;
}
